const ENV = import.meta.env;

const parseEnvNumber = (value, fallback) => {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
};

/** Default map center — Mumbai unless overridden in .env */
const MAP_DEFAULT_LAT = parseEnvNumber(ENV.VITE_MAP_DEFAULT_LAT, 19.076);
const MAP_DEFAULT_LNG = parseEnvNumber(ENV.VITE_MAP_DEFAULT_LNG, 72.8777);

export const AppConfig = {
  SITE_DEFAULT_TITLE: "Water Logging Monitor System",
  SOCKET_URL: ENV.VITE_REACT_APP_SOCKET_URL,
  MAP_DEFAULT_LAT,
  MAP_DEFAULT_LNG,
  MAP_DEFAULT_CENTER: [MAP_DEFAULT_LAT, MAP_DEFAULT_LNG],
};
